import { Link, useLocation, useSearchParams } from "react-router-dom";

// Preserve only client/property context between List and Calendar views.
function extractContextParams(searchParams) {
  const next = new URLSearchParams();
  const client = searchParams.get("client");
  const property = searchParams.get("property");
  if (client && /^[1-9]\d*$/.test(client)) next.set("client", client);
  if (property && /^[1-9]\d*$/.test(property)) next.set("property", property);
  return next;
}

function tabHref(to, contextParams) {
  const qs = contextParams.toString();
  return qs ? `${to}?${qs}` : to;
}

/**
 * Two-tab navigation: Список and Календар.
 * Preserves client/property context between tabs.
 * Does NOT carry list-specific params or calendar-specific params to the other tab.
 */
function TasksViewTabs() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const contextParams = extractContextParams(searchParams);

  const listHref = tabHref("/tasks", contextParams);
  const calendarHref = tabHref("/tasks/calendar", contextParams);

  const isCalendar = location.pathname === "/tasks/calendar";
  const isList = !isCalendar && location.pathname.startsWith("/tasks");

  return (
    <nav
      className="feature-tasks-view-tabs"
      aria-label="Перегляд задач"
    >
      <Link
        to={listHref}
        className={[
          "feature-tasks-view-tabs__tab",
          isList ? "feature-tasks-view-tabs__tab--active" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        aria-current={isList ? "page" : undefined}
      >
        Список
      </Link>
      <Link
        to={calendarHref}
        className={[
          "feature-tasks-view-tabs__tab",
          isCalendar ? "feature-tasks-view-tabs__tab--active" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        aria-current={isCalendar ? "page" : undefined}
      >
        Календар
      </Link>
    </nav>
  );
}

export default TasksViewTabs;
